export default __webpack_public_path__ + "static/media/Bluefish-5.9ee96163.png";